const cx = (...parts) => parts.filter(Boolean).join(" ");

export function Input({ invalid, className, ...rest }) {
  return <input className={cx("rl-input", invalid && "rl-input--invalid", className)} {...rest} />;
}

export function Select({ invalid, className, children, ...rest }) {
  return <select className={cx("rl-select", invalid && "rl-select--invalid", className)} {...rest}>{children}</select>;
}

export function Textarea({ invalid, className, ...rest }) {
  return <textarea className={cx("rl-textarea", invalid && "rl-textarea--invalid", className)} {...rest} />;
}

export default Input;
